import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import SubHead from '../SubHead/SubHead';
import BodyText from '../BodyText/BodyText';
import RelatedArticle from './RelatedArticle';
import './related-module.scss';
import { isValid } from '../../../../utils';

const RelatedModule = ({
  data,
  settings={},
  isMobile,
  className,
  slug,
  isPage=false,
}) => {
  if(!isValid(data)) {
    return null;
  }
  const { header, hedBody, articles=[] } = data;
  const { articleLayout='' } = settings;
  const isContentHub = (articleLayout === 'Content Hub');
  const width = (articles.length > 2 && articleLayout === 'Standard') ? 'slim' : 'regular';
  
  let articleType;
  
  switch (articleLayout) {
    case 'Content Hub':
      articleType = 'content-hub'
      break;
    case 'Guide':
      articleType = 'guide'
      break;
    case 'Standard':
      articleType = 'standard'
      break;
    default:
      break;
  }
  if (isPage) {
    articleType = 'page';
  }

  // To remove empty space and p tags from hedBody (where no text entered in Editor in Header Body field, it's coming through as " <p></p> " in the REST)
  const removeTags = (str) => {
    if (!isValid(str)) {
      return '';
    }

    try {
      // convert '&lt;' and '&gt;' to p tags
      const regexed = str.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
      // trim whitespace and remove p tags from the str
      const transformed = regexed.replace(/<[^\/>]*>([\s]?)*<\/[^>]*>/, '').trim();
      return transformed;
    } catch (e) {
      console.log(e);
      return '';
    }
    
  };
  const transformedHedBody = removeTags(hedBody);
  const isEmpty = (transformedHedBody === '');

  const multi = isMobile ? 'row-1x' : 'row-3x';
  console.log(articleType, data);

  return (
    // className will be 'related-stories' as is declared in ArticleModules.js
    <div className={className + ' ' + articleType}>
      <Fragment>
        {/* only want to show this SubHead if the article is not a CH */}
        {(!isContentHub && header !== '' && header !== null) &&
          <SubHead className="related-module-hed" data={header} />
        }
        {!isEmpty && 
          <Fragment>
            <BodyText className={`related-module-header-body ${articleType}`} data={hedBody} />
          </Fragment>
        }
        <div className="related-stories-container-wrapper">
          <div className={`${className}-wrapper ${multi} ${width}`}>
              {articles.map((article, index) => (
                  <RelatedArticle
                      index={index}
                      key={article.articleId}
                      article={article}
                      className="related-story"
                      slug={slug}
                      isMobile={isMobile}
                      isPage={isPage}
                  />
              ))}
          </div>
        </div>
      </Fragment>
    </div>
  );
};


RelatedModule.propTypes = {
  data: PropTypes.object,
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  slug: PropTypes.string,
};

export default RelatedModule;
